import React, { useState } from "react";
import { Header } from "../../components/Header";
import { Footer } from "../../components/FooterV2";
import { PriceSystemCompare } from "../../blocks/price-system-compare";
import { Helmet } from "react-helmet";
import { PricePageBanner } from "../../blocks/pricePage-banner";
import { PriceList } from "../../blocks/pricePage-list";
import { PrivateCloudQuestion } from "../../blocks/private-cloud-question";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { PriceBanner } from "../../blocks/price-banner";
import { Notice } from "../../components/Notice";

export const PricePage = () => {
  const { t } = useTranslation();
  const [currentType, setCurrentType] = useState("b2c");
  const questions = [
    {
      title: t("price.question.item-one.title"),
      detail: [
        <>
          {t("price.question.item-one.descript")}
          <a href="https://blog.authing.cn/blog/15">
            {t("price.question.item-one.link")}
          </a>
        </>,
      ],
    },
    {
      title: t("price.question.item-two.title"),
      detail: [<>{t("price.question.item-two.descript")}</>],
    },
    {
      title: t("price.question.item-three.title"),
      detail: [<>{t("price.question.item-three.descript")}</>],
    },
    {
      title: t("price.question.item-four.title"),
      detail: [
        <>{t("price.question.item-four.other")}</>,
        <>{t("price.question.item-four.descript-one")}</>,
        <>{t("price.question.item-four.descript-two")}</>,
        <>{t("price.question.item-four.descript-three")}</>,
        <>{t("price.question.item-four.descript-four")}</>,
        <>
          <a href="https://docs.authing.cn/v2/">
            {t("price.question.item-four.link")}
          </a>
        </>,
      ],
    },
  ];
  return (
    <div className="price-page">
      <Helmet>
        <title>
          Authing统一身份认证免费试用，单点登录SSO价格，用户统一身份认证价格-Authing身份云
        </title>
      </Helmet>
      <Header hasNotice />
      <PricePageBanner />
      <PriceList currentType={currentType} setCurrentType={setCurrentType} />
      <PriceSystemCompare currentType={currentType} />
      <PrivateCloudQuestion
        background="none"
        itemBG="#FAFBFC"
        questions={questions}
      ></PrivateCloudQuestion>
      <Footer />
    </div>
  );
};
